"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var ResponsiveImage_1 = tslib_1.__importDefault(require("../../ResponsiveImage"));

var styles = tslib_1.__importStar(require("./ContentsCard.style"));

function ContentsCard(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      backgroundColor = _ref.backgroundColor,
      imgUrl = _ref.imgUrl,
      link = _ref.link;
  return jsx_runtime_1.jsx("a", Object.assign({
    href: link
  }, {
    children: jsx_runtime_1.jsx("div", Object.assign({
      css: styles.container
    }, {
      children: jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.wrapper(backgroundColor)
      }, {
        children: [jsx_runtime_1.jsx("div", Object.assign({
          css: styles.imageWrapper
        }, {
          children: jsx_runtime_1.jsx("div", Object.assign({
            css: styles.image
          }, {
            children: jsx_runtime_1.jsx(ResponsiveImage_1.default, {
              src: imgUrl
            }, void 0)
          }), void 0)
        }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
          css: styles.titleWrapper
        }, {
          children: [jsx_runtime_1.jsx("div", Object.assign({
            css: styles.title
          }, {
            children: title
          }), void 0), jsx_runtime_1.jsx("div", Object.assign({
            css: styles.subTitle
          }, {
            children: subTitle
          }), void 0)]
        }), void 0)]
      }), void 0)
    }), void 0)
  }), void 0);
}

exports.default = ContentsCard;